<div class="directory-page-container">
  <div class="combined-header">
    <public-header></public-header>
    <div class="find-by-filters">
      <h1 id="header-title" class="find-a-therapist header-contents header-title" data-test="find-a-therapist-header">
        Find a therapist {{selectedState ? 'in ' + selectedState : ''}}
        {{currentFormFilters?.insurance?.pncId >= 0 && currentFormFilters?.insurance?.title ? 'that accepts ' + currentFormFilters.insurance.title : ''}}
      </h1>
      <filter-form
        class="header-contents filters"
        id="header-filters"
        (filtersChanged)="onFiltersChanged($event)"
        (filterRetrievalError)="onFilterRetrievalError($event)"
        (formValuesChanged)="onFormValuesChanged($event)"
        (updateDynamicSeo)="onUpdateDynamicSeo($event)"
        data-test="filter-form"
      ></filter-form>
      <h2 
        *ngIf="showProviderCountMessage" 
        id="header-count"
        class="available-provider-count header-contents"
        data-test="provider-count"
      >
        {{ totalProviderCount | pluralize:'provider':'providers' }} accepting new clients
      </h2>
    </div>
  </div>

  <main>
    <div class="scrollable-area">
      <section class="filterable-directory-body">
        <div *ngIf="showErrorMessageFiltersRetrieval; else pageFunctionalTemplate" class="no-filters-error">
          <filters-error></filters-error>
        </div>

        <ng-template #pageFunctionalTemplate>
          <div
            *ngIf="
              !locationFilterApplied
              || loadingInitialResults
              || !(filterOptionsStore.isLoaded$() | async)
              else locationFilterAppliedTemplate"
            class="no-results-message">
            <div *ngIf="!(breakpointService.isMobileOrTablet$ | async) then desktopSkeleton; else mobileSkeleton"></div>
          </div>
      
          <ng-template #locationFilterAppliedTemplate>      
            <div *ngIf="showErrorMessageResultsRetrieval && !loadingInitialResults" class="no-results-message">
              <general-error></general-error>
            </div>
            <div *ngIf="!showErrorMessageResultsRetrieval && !loadingInitialResults">
              <ng-container *ngIf="results$ | async as results">
                <div *ngIf="results.length > 0; else noResults" class="provider-results">
                  <provider-listing-card
                    class="provider-listing"
                    *ngFor="let providerListing of results; index as i"
                    [currentFormFilters]="currentFormFilters"
                    [providerIndex]="i"
                    [providerListing]="providerListing"
                    [paramMap]="paramMap$ | async"
                    [queryParams]="queryParams$ | async"
                    [selectedState]="selectedState"
                    [providerSoonestAvailability]="(providersSoonestAvailability$ | async)[providerListing.id]"
                  ></provider-listing-card>
                  <button 
                    *ngIf="!reachedFinalProviderResultPage && !loadingAdditionalResults"
                    type="button" 
                    class="show-more"
                    (click)="requestTherapists()"
                    data-test="show-more-button"
                  >
                    Show more providers
                  </button>
                </div>
              </ng-container>
              <div *ngIf="loadingAdditionalResults" class="bottom-loader">
                <div *ngIf="!(breakpointService.isMobileOrTablet$ | async) then desktopSkeleton; else mobileSkeleton"></div>
              </div>
              <ng-template #noResults>
                <no-results></no-results>
              </ng-template>
            </div>
          </ng-template>    
        </ng-template>
      </section> 
      <div 
        *ngIf="!locationFilterApplied || loadingInitialResults else helpSection" 
        class="no-results-message"
      >
        <div
          *ngIf="!(breakpointService.isMobile$ | async)"
          class="skeleton-card-faq"
          [class.shimmer]="loadingInitialResults"
        ></div>
      </div>
      <ng-template #helpSection>
        <faq-dropdown #helpSection/>
      </ng-template>
    </div>
  </main>

  <public-footer [currentStateAbbrev]="selectedStateAbbrev" [matchflowBaseUrl]="matchflowBaseUrl"></public-footer>
</div>

<ng-template #desktopSkeleton>
  <div
    *ngFor="let card of skeletonCards"
    class="skeleton-card"
    data-test="skeleton-card"
    [class.shimmer-parent]="loadingInitialResults || loadingAdditionalResults"
  >
    <div class="skeleton-image shimmer-child"></div>
    <div class="skeleton-text-container">
      <div class="skeleton-text shimmer-child"></div>
      <div class="skeleton-text skeleton-text-title shimmer-child"></div>
      <div class="skeleton-text skeleton-text-content shimmer-child"></div>        
    </div>
    <div class="skeleton-button-container">
      <div class="skeleton-button shimmer-child"></div>
      <div class="skeleton-button shimmer-child"></div>
    </div>
  </div>
</ng-template>

<ng-template #mobileSkeleton>
  <div
    *ngFor="let card of skeletonCards"
    class="skeleton-card-mobile"
    [class.shimmer-parent]="loadingInitialResults || loadingAdditionalResults"
  >
    <div class="skeleton-image-mobile shimmer-child"></div>
    <div class="skeleton-text-container-mobile">
      <div class="skeleton-text-mobile shimmer-child"></div>
      <div class="skeleton-text skeleton-text-title-mobile shimmer-child"></div>
    </div>
    <div class="skeleton-text skeleton-text-content-mobile shimmer-child"></div>        
    <div class="skeleton-button-container-mobile">
      <div class="skeleton-button-mobile shimmer-child"></div>
      <div class="skeleton-button-mobile shimmer-child"></div>
    </div>
  </div>
</ng-template>